export default __webpack_public_path__ + "static/media/profile.682cb174.svg";